import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=b044361c&scoped=true&"
import script from "./paging.vue?vue&type=script&lang=ts&"
export * from "./paging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b044361c",
  null
  
)

export default component.exports